const API_URL = process.env.REACT_APP_API_URL;

// Reverse Proxy Controllers
const AREA_SUBSCRIPTION = API_URL + "/subscription/";
const ADMIN_ORGANIZATION_PRODUCT_SUBSCRIPTION = "/OrganizationProductSubscriptionAdmin/";

// Web Controllers
const PRODUCT = "Product/";
const BILLING_LINE = "BillingLine/";
const STORE = "Store/";
const ORGANIZATION_PRODUCT_SUBSCRIPTION = "OrganizationProductSubscription/";
const FEE_WAIVER = "FeeWaiver/";
const FEE_WAIVER_SUBSCRIPTION = "FeeWaiverSubscription/";

export const SubscriptionApiUrl = {
    PRODUCT_BASEURL: AREA_SUBSCRIPTION + PRODUCT
    , BILLING_LINES_LIST: AREA_SUBSCRIPTION + BILLING_LINE + "GetList?productCategoryId="
    , BILLING_LINES_UPDATE: AREA_SUBSCRIPTION + BILLING_LINE + "Update?id="
    , STORE_GETPRICING: AREA_SUBSCRIPTION + STORE + "ProductPricing/Product/{0}/Info/{1}"
    , STORE_GETSELECTED_PRODUCT_SUBSCRIPTIONS: AREA_SUBSCRIPTION + STORE + "ProductPricing/VSTT/Product?"
    , STORE_REQUIRE_BASE_SUBSCRIPTION: AREA_SUBSCRIPTION + STORE + "ProductSubscriptionCheck/VSTS/Base"
    , STORE_GET_FUTURE_VSTS_SUBSCRIPTION: AREA_SUBSCRIPTION + STORE + "ProductSubscription/VSTS/Base/FutureSubscription"
    , STORE_GET_ACTIVE_VSTS_SUBSCRIPTION: AREA_SUBSCRIPTION + STORE + "ProductSubscription/VSTS/Base/ActiveSubscription"
    , STORE_PLACE_ORDER : AREA_SUBSCRIPTION + STORE + "PlaceOrder/Organization/{0}"
    , STORE_CHECK_VSTT_SUBSCRIPTION_EXIST: AREA_SUBSCRIPTION + STORE + "ProductSubscriptionCheck/VSTT/Product"
    , ORGANIZATION_GET_ORGANIZATION_PRODUCT_SUBSCRIPTION_LSIT: AREA_SUBSCRIPTION + ORGANIZATION_PRODUCT_SUBSCRIPTION + "GetAll"
    , ADMIN_ORGANIZATION_GET_ORGANIZATION_PRODUCT_SUBSCRIPTION_LSIT: API_URL + ADMIN_ORGANIZATION_PRODUCT_SUBSCRIPTION + "GetAll"
    , ADMIN_ORGANIZATION_EXPORT_ALL_ORGANIZATION_PRODUCT_SUBSCRIPTION: API_URL + ADMIN_ORGANIZATION_PRODUCT_SUBSCRIPTION + "ExportAll"
    , ORGANIZATION_PRODUCT_SUBSCRIPTION_GET: AREA_SUBSCRIPTION + ORGANIZATION_PRODUCT_SUBSCRIPTION + "Get/"
    , ORGANIZATION_PRODUCT_SUBSCRIPTION_GET_LATEST_NON_FUTURE_SUBSCRIPTION: AREA_SUBSCRIPTION + ORGANIZATION_PRODUCT_SUBSCRIPTION + "GetLatestNonFutureVstsSubscription"
    , ORGANIZATION_PRODUCT_SUBSCRIPTION_UPDATE_VSTS_SUBSCRIPTION_DATES: AREA_SUBSCRIPTION + ORGANIZATION_PRODUCT_SUBSCRIPTION + "UpdateVstsSubscriptionDates"
    , ORGANIZATION_PRODUCT_SUBSCRIPTION_CANCEL: AREA_SUBSCRIPTION + ORGANIZATION_PRODUCT_SUBSCRIPTION + "Cancel/"
    , FEE_WAIVER_GET: AREA_SUBSCRIPTION + FEE_WAIVER + "GetFeeWaiver/"
    , FEE_WAIVER_OPTIONS: AREA_SUBSCRIPTION + FEE_WAIVER_SUBSCRIPTION + "GetFeeWaiverOptions"
}
